module.exports = __webpack_public_path__ + "img/187.e08ce17e.jpg";